import * as Contentful from 'contentful'
import * as CFRichTextTypes from '@contentful/rich-text-types'

export enum DescriptionSizeImage {
  Large = 'large',
  Medium = 'medium',
}

export interface TypeAssetImageFields {
  internalName: Contentful.EntryFields.Symbol
  title?: Contentful.EntryFields.Symbol
  asset: Contentful.Asset | undefined
  isRounded?: Contentful.EntryFields.Boolean | undefined
  description?: CFRichTextTypes.Document
  descriptionSize?: DescriptionSizeImage | undefined
}

export type ImageAssetContentType = 'image/jpeg' | 'image/png' | 'image/svg+xml' | 'image/webp' | 'image/gif' | string

export type TypeAssetImage = Contentful.Entry<TypeAssetImageFields>
